import { css } from '@emotion/react';
import 'react-popper-tooltip/dist/styles.css';

export default css`
  .tooltip-container {
    --tooltipBackground: #3b3cff;
    --tooltipBorder: #3b3cff;
    --tooltipColor: #ffffff;
    padding: 16px 24px;
    border-radius: 8px;
  }
`;
